// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1y21D","productName":"Table_productName__1IUFx"};